import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import enTranslations from "./locales/en/translation.json"
import esTranslations from "./locales/es/translation.json"
import heTranslations from "./locales/he/translation.json"

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      es: {
        translation: esTranslations,
      },
      he: {
        translation: heTranslations,
      },
    },
    fallbackLng: "he",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
